const languages: {[key: string]: string} = {
    English: "en-US",
    EnglishCanadian: "en-CA",
    Spanish: "es-ES",
    SpanishUS: "es-US",
    SpanishPR: "es-PR",
    SpanishMX: "es-MX",
    French: "fr-FR",
    FrenchCanadian: "fr-CA",
    Chinese: "zh-CN",
    Arabic: "ar-SA",
};

const languageConstants = {
        languages: languages,
        default: "English",
};



const normalizeLanguage = function (a: string){
    switch(a.toLowerCase())
    {
        //Spanish
        case "es":
        case "es-es":
        case "es_es":
            return "es-ES";

        case "es-us":
        case "es_us":
            return "es-US";
        
        case "es-pr":
        case "es_pr":
            return "es-PR";
            
        case "es-mx":
        case "es_mx":
            return "es-MX";

        //English
        case "en":
        case "en-us":
        case "en_us":
            return "en-US";

        //Canadian English
        case "enca":
        case "en-ca":
        case "en_ca":
            return "en-CA";

        //French
        case "fr":
        case "fr-fr":
        case "fr_fr":
            return "fr-FR";

        //French Canadian
        case "frca":
        case "fr-ca":
        case "fr_ca":
            return "fr-CA";

        //Simplified Chinese
        case "zh":
        case "zh-cn":
        case "zh_cn":
            return "zh-CN";

        //Araboc
        case "ar-ae":
        case "ar_ae":
        case "ar-sa":
        case "ar_sa":
        case "ar":
            return "ar-SA";
    }
    return a;
};

//default to the language of the page if it's available
const pageLanguage = normalizeLanguage(document.documentElement.lang);

Object.keys(languageConstants.languages).forEach(function(key) {
    if (languageConstants.languages[key] == pageLanguage) {
        languageConstants.default = key;
    }
  });

export {
    languageConstants
};




// WEBPACK FOOTER //
// ./settings/language-constants.ts